/* ============================================================
   DBA COUTURE — Formulaire de contact : ergonomie + anti-spam
   Asset : dba-contact.js  (section : dba-contact.liquid)
   ------------------------------------------------------------
   • Réactive le champ technique « form_type » seulement après une
     VRAIE interaction humaine + un délai minimum (sinon Shopify
     refuse l'envoi : les robots qui postent en direct échouent).
   • Pot de miel, limite de liens, vérification des champs.
   • Ajoute « ⚠ À vérifier » dans l'e-mail si le message ressemble
     à une arnaque connue (non bloquant).
   • Affiche le champ « Date de l'événement » pour mariage / soirée / scène,
     adapte l'exemple du message, pré-sélection via ?projet=…
   ============================================================ */
(function () {
  'use strict';

  var SCAM_RULES = [
    [/shipping agent|shipper|my mover|moving company|courier|pick ?up (the|my)|transporteur (priv|à moi|de mon)|mon transporteur|déménageur|coursier/i,
      'propose son propre transporteur / coursier'],
    [/cashier'?s? ch(eck|[eè]que)|certified ch(eck|[eè]que)|bank ch(eck|[eè]que)|money ?order|ch[eè]que (de banque|certifi)|western ?union|moneygram|wire transfer|excess (amount|payment)|overpay|trop[- ]perçu/i,
      'mode de paiement typique des arnaques (chèque de banque, Western Union, trop-perçu…)'],
    [/bitcoin|crypto|usdt|ethereum|binance|blockchain/i,
      'parle de crypto-monnaie'],
    [/\bseo\b|backlinks?|guest post|first page of google|google ranking|référencement (naturel|google)|website (redesign|traffic)|web ?design(er)? services?|marketing services?|more (sales|leads|traffic)|social media (management|growth)/i,
      'démarchage commercial (SEO, site web, marketing…)'],
    [/(gift|surprise|present) for my (wife|husband|daughter|son|mother)|wedding anniversary|at sea|offshore|oil rig|deployed|on a (ship|vessel)|relocating/i,
      'scénario classique de faux acheteur d\'œuvre ("cadeau pour ma femme", "je suis en mer"…)'],
    [/whats ?app|telegram|signal app|text me (on|at)/i,
      'demande de continuer sur WhatsApp / Telegram'],
    [/\bloan\b|prêt entre particuliers|investment opportunit|inheritance|héritage|lottery|loterie|beneficiary|bénéficiaire/i,
      'prêt, héritage, loterie ou investissement'],
    [/verify your (account|store)|shopify (support|team)|your (store|account) (will be|has been) (suspended|closed)|copyright (infringement|violation)|violation des droits/i,
      'faux message « Shopify » ou faux avertissement de droits d\'auteur']
  ];

  var EN_WORDS = /\b(the|and|you|your|my|is|are|for|with|please|would|like|this|that|have|interested|purchase|buy|price|hello|hi|dear|regards|thanks)\b/gi;
  var FR_WORDS = /\b(le|la|les|et|vous|votre|je|de|des|pour|avec|une|un|bonjour|merci|est|suis|robe|mariage|projet|j'|c'est)\b/gi;

  var PH = [
    [/mari/i, 'Parlez-moi de votre mariage : la date, le lieu, l\'ambiance, la robe dont vous rêvez… Même en vrac, c\'est parfait.'],
    [/soir/i, 'Pour quelle occasion ? Plutôt long, court, fluide, structuré ? Une couleur en tête ?'],
    [/sc[eè]ne|drag|costume/i, 'Votre personnage, votre show, l\'effet que vous voulez faire en entrant sur scène…'],
    [/cravate/i, 'Une cravate en particulier ? Une idée de broderie, une personnalisation, un cadeau ?'],
    [/tableau/i, 'Quel tableau vous a tapé dans l\'œil ? Une question sur un format, une commande ?']
  ];

  function countLinks(t) {
    var m = t.match(/(https?:\/\/|www\.|\b[a-z0-9-]+\.(com|net|org|io|ru|cn|xyz|info|biz|top|site|online|shop|link|click)\b)/gi);
    return m ? m.length : 0;
  }

  function init(root) {
    var form = root.querySelector('#DbaContactForm');
    if (!form || form.dataset.dbaReady) return;
    form.dataset.dbaReady = '1';
    form.noValidate = true;

    var minMs = (parseInt(root.dataset.minSeconds, 10) || 4) * 1000;
    var maxLinks = parseInt(root.dataset.maxLinks, 10);
    if (isNaN(maxLinks)) maxLinks = 1;
    var flagScam = root.dataset.flagScam === 'true';
    var flagEn = root.dataset.flagEnglish === 'true';

    var t0 = Date.now();
    var human = false;
    var ft = form.querySelector('[data-dba-name="form_type"]');
    var hp = form.querySelector('#DbaContact-hp');
    var msgBox = form.querySelector('[data-dba-msg]');
    var btn = form.querySelector('[data-dba-submit]');
    var body = form.querySelector('#DbaContact-body');
    var dateWrap = form.querySelector('[data-dba-date]');
    var dateInput = dateWrap && dateWrap.querySelector('input');
    var defaultPh = body ? body.getAttribute('placeholder') : '';

    function armed() { return human && Date.now() - t0 >= minMs; }
    function arm() {
      if (ft && armed()) ft.setAttribute('name', 'form_type');
    }
    function onHuman(e) {
      if (e && e.isTrusted === false) return;
      if (!human) {
        human = true;
        var wait = Math.max(0, minMs - (Date.now() - t0));
        setTimeout(arm, wait + 20);
      }
      arm();
    }
    ['pointerdown', 'keydown', 'touchstart', 'focusin', 'input'].forEach(function (ev) {
      form.addEventListener(ev, onHuman, { passive: true });
    });

    function say(text) {
      if (!msgBox) return;
      msgBox.textContent = text;
      msgBox.hidden = !text;
    }

    /* ---------- Projet : date + exemple adapté ---------- */
    function onProject() {
      var c = form.querySelector('input[name="contact[Projet]"]:checked');
      var v = c ? c.value : '';
      var needDate = /mari|soir|sc[eè]ne|costume|drag/i.test(v);
      if (dateWrap) {
        dateWrap.hidden = !needDate;
        if (dateInput) dateInput.disabled = !needDate;
      }
      if (body) {
        var ph = defaultPh;
        for (var i = 0; i < PH.length; i++) { if (PH[i][0].test(v)) { ph = PH[i][1]; break; } }
        body.setAttribute('placeholder', ph);
      }
    }
    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'contact[Projet]') onProject();
    });

    /* Pré-sélection : /pages/contact?projet=mariage */
    try {
      var want = new URLSearchParams(location.search).get('projet');
      if (want) {
        want = want.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
        var radios = form.querySelectorAll('input[name="contact[Projet]"]');
        for (var r = 0; r < radios.length; r++) {
          var lab = radios[r].value.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
          if (lab.indexOf(want.slice(0, 4)) !== -1) { radios[r].checked = true; break; }
        }
      }
    } catch (e) {}
    onProject();

    /* ---------- Envoi ---------- */
    form.addEventListener('submit', function (e) {
      say('');
      var name = form.querySelector('#DbaContact-name');
      var email = form.querySelector('#DbaContact-email');
      var text = body ? body.value.trim() : '';

      // 1. Pot de miel rempli → robot : on n'envoie rien, sans rien dire.
      if (hp && hp.value) { e.preventDefault(); if (ft) ft.removeAttribute('name'); return; }

      // 2. Champs obligatoires, avec un message gentil.
      var bad = null;
      [name, email, body].forEach(function (el) { if (el) el.removeAttribute('aria-invalid'); });
      if (name && name.value.trim().length < 2) bad = [name, 'Comment dois-je vous appeler ? Indiquez votre prénom et votre nom.'];
      else if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) bad = [email, 'Il me faut une adresse e-mail valide pour pouvoir vous répondre.'];
      else if (text.length < 15) bad = [body, 'Dites-m\'en un tout petit peu plus, quelques mots suffisent.'];
      if (bad) {
        e.preventDefault();
        bad[0].setAttribute('aria-invalid', 'true');
        bad[0].focus();
        say(bad[1]);
        return;
      }

      // 3. Trop de liens.
      if (countLinks(text) > maxLinks) {
        e.preventDefault();
        say(maxLinks === 0
          ? 'Pour éviter les spams, les liens ne sont pas acceptés dans le message. Décrivez-moi simplement votre projet, je vous répondrai par e-mail.'
          : 'Pour éviter les spams, ' + maxLinks + ' lien maximum dans le message, merci.');
        return;
      }

      // 4. Trop rapide / pas d'interaction réelle.
      if (!armed()) {
        e.preventDefault();
        human = true;
        var wait = Math.max(0, minMs - (Date.now() - t0));
        say('Une petite seconde… vérification anti-robots en cours, cliquez à nouveau sur le bouton.');
        setTimeout(function () { arm(); say(''); }, wait + 20);
        return;
      }
      arm();
      if (!ft || !ft.getAttribute('name')) {
        // Sécurité : si le champ a disparu, on le recrée.
        if (!form.querySelector('input[name="form_type"]')) {
          var f = document.createElement('input');
          f.type = 'hidden'; f.name = 'form_type'; f.value = 'contact';
          form.appendChild(f);
        }
      }

      // 5. Alerte « à vérifier » pour Dorian (non bloquant).
      var old = form.querySelector('input[data-dba-flag]');
      if (old) old.remove();
      var flags = [];
      if (flagScam) {
        SCAM_RULES.forEach(function (rule) { if (rule[0].test(text)) flags.push(rule[1]); });
        var n = countLinks(text);
        if (n) flags.push('contient ' + n + ' lien' + (n > 1 ? 's' : ''));
        if (/[Ѐ-ӿ一-鿿]/.test(text)) flags.push('écrit en alphabet cyrillique ou chinois');
      }
      if (flagEn) {
        var en = (text.match(EN_WORDS) || []).length;
        var fr = (text.match(FR_WORDS) || []).length;
        if (en >= 4 && en > fr * 1.5) flags.push('message en anglais (prudence si on vous parle de paiement ou de transporteur)');
      }
      if (flags.length) {
        var flag = document.createElement('input');
        flag.type = 'hidden';
        flag.name = 'contact[⚠ À vérifier]';
        flag.value = flags.join(' · ');
        flag.setAttribute('data-dba-flag', '');
        form.appendChild(flag);
      }

      if (hp) hp.removeAttribute('name'); // champ vide : inutile dans l'e-mail
      ['#DbaContact-phone', '#DbaContact-date'].forEach(function (sel) {
        var el = form.querySelector(sel);
        if (el && !el.value.trim()) el.disabled = true; // facultatif et vide : pas envoyé
      });
      if (btn) btn.setAttribute('aria-busy', 'true');
    });
  }

  function boot() {
    document.querySelectorAll('[data-dba-contact]').forEach(init);
    var ok = document.querySelector('.dba-ct__success');
    if (ok) {
      ok.scrollIntoView({ behavior: 'smooth', block: 'center' });
      ok.focus({ preventScroll: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-dba-contact]');
    if (r) init(r);
  });
})();
